module.exports = __webpack_public_path__ + "img/giftpackage_level1.1f55593f.png";